// in src/posts.js
import React from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import {
    BooleanField,
    DateField,
    Show,
    SimpleShowLayout,
    SimpleList,
    Filter,
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    ShowButton,
    SimpleForm,
    TextInput
} from 'react-admin';
import { OnlyShowActionsDetail, OnlyShowActionsList } from './FieldComponents/OnlyShowActions';

const CartFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="user" alwaysOn />
    </Filter>
);

export const CartList = (props) => {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <List {...props} title="Listar Carritos" filters={<CartFilter />} actions={<OnlyShowActionsList />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.user}
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="user" label="Usuario" />
                    <TextField source="ip" />
                    <TextField source="state" label="Estado" />
                    <ShowButton />
                    <EditButton />
                </Datagrid>
            )}
        </List>
    );
};

const CartName = ({ record }) => {
    return <span>Carrito {record ? `"${record.user}"` : ''}</span>;
};

export const CartEdit = (props) => (
    <Edit title={<CartName />} {...props}>
        <SimpleForm>
            <TextInput source="id" disabled />
            <TextInput source="user" />
            <TextInput source="ip" />
            <TextInput source="lotteries" />
            <TextInput source="recharges" />
            <TextInput source="order" />
            <TextInput label="Estado" source="state" />
        </SimpleForm>
    </Edit>
);

export const CartCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="user" />
            <TextInput source="ip" />
            <TextInput source="lotteries" />
            <TextInput source="recharges" />
            <TextInput source="order" />
            <TextInput label="Estado" source="state" />
        </SimpleForm>
    </Create>
);

export const CartShow = (props) => (
    <Show title={<CartName />} {...props} actions={<OnlyShowActionsDetail />}>
        <SimpleShowLayout>
            <TextField source="user" label="Usuario" />
            <TextField source="ip" />
            <TextField source="state" label="Estado" />
            <DateField label="Fecha de Actualización" source="updatedAt" />
            <DateField label="Fecha de Publicación" source="createdAt" />
        </SimpleShowLayout>
    </Show>
);
